import Offline from 'offline-js'; // eslint-disable-line
import 'offline-js/themes/offline-theme-default.css';
import 'offline-js/themes/offline-language-english.css';

const useOfflineIndicator = () => {
  window.Offline.options = {reconnect: {initialDelay: 10}};
}

export default useOfflineIndicator;
